import { styled as muiStyled } from '@mui/material'

export const EmrReportImagesViewerContainer = muiStyled('div')(
  ({ theme, hiddenInUI = false }) => `
  display: ${hiddenInUI ? 'none' : 'block'};
    @media print {
        display: block;
    }
`,
)
